module.exports = __webpack_public_path__ + "static/media/pivot-data-icon.69d81eaf.svg";